export const DEPOSIT_UNIT_OPTIONS = [
  {
    label: 'ETH',
    value: 'ETH',
  },
  {
    label: 'BNB',
    value: 'BNB',
  },
  {
    label: 'USDT',
    value: 'USDT_BEP20',
  },
]